import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useState } from 'react';
import CustomModal from '../../../../components/modal/CustomModal';
import { useTranslation } from 'react-i18next';
import { StripeError } from '@stripe/stripe-js';

function StripeCardForm({
  shouldShowModel,
  onCloseAddCardForm,
}: {
  shouldShowModel: boolean;
  onCloseAddCardForm: (shouldRefresh: boolean) => void;
}) {
  const { t }: any = useTranslation();
  const stripe = useStripe();
  const elements = useElements();

  const [stripeError, setStripeError] = useState<StripeError | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleSubmit = async () => {
    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsSubmitting(true);

    const result = await elements.submit();

    if (result.error) {
      setStripeError(result.error);
      setIsSubmitting(false);
      // Handle error
    } else {
      const { error } = await stripe.confirmSetup({
        elements,
        redirect: 'if_required',
      });

      if (error) {
        setStripeError(error);
      } else {
        onCloseAddCardForm(true);
        setIsSubmitting(false);
      }
      setIsSubmitting(false);
    }
  };

  const paymentElement = elements?.getElement('payment');
  paymentElement?.collapse();

  return (
    <CustomModal
      size={'sm'}
      show={shouldShowModel}
      title={t('Enter Card Details')}
      confirmText={t('Save Card')}
      showCancelButton={false}
      handleConfirm={() => handleSubmit()}
      handleCancel={() => {
        onCloseAddCardForm(false);
      }}
      isSubmitting={isSubmitting}
    >
      <>
        <PaymentElement />
        {stripeError && <div className='error-message'>{stripeError.message}</div>}
      </>
    </CustomModal>
  );
}

export default StripeCardForm;
